import axios from "../../../configs/axios"

export const toggleActiveApplicationAPI = async(app)=>{
  const response = await axios.put(`application/update/${app?.id}`, { status: app?.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' })
  return response?.data
}